/**
 * Service for working with consumer keys.
 */
const ConsumerKeyService = () => {

    /**
     * Get the customer ID from a consumer key.
     */
    const customerIdFromKey = (key: string): number | null => {
        const parts = key.split("_");

        if (parts.length !== 2) {
            return null;
        }

        if (parts[0] !== 'c' || isNaN(parseInt(parts[1]))) {
            return null;
        }

        return parseInt(parts[1]);
    };

    /**
     * Transform customer ID to consumer key.
     *
     * @param customerId
     */
    const consumerKeyFromCustomerId = (customerId: number): string | null => {
        if (isNaN(customerId)) {
            return null;
        }

        return `c_${customerId}`;
    };

    /** Tell if the provided key is a beneficiary key. */
    const isBeneficiary = (key: string): boolean => {
        const parts = key.split("_");

        if (parts.length === 2) {
            return parts[0] === 'b';
        }

        return false;
    };

    /**
     * Get the default key of a consumer or composite key: the first segment
     * of a reconciliation composite key ("c_1-b_2") is the patient reference
     * profile, a plain key is returned as is.
     */
    const defaultKey = (key: string): string => {
        return key.split("-")[0];
    };

    return {
        customerIdFromKey,
        consumerKeyFromCustomerId,
        isBeneficiary,
        defaultKey
    };
};

export default ConsumerKeyService();
